import { BrowserRouter , Routes, Route as BrowserRoute  } from 'react-router-dom';
import BuilderRoute from './Route/BuilderRoute';
import { useLocation, matchPath } from 'react-router-dom';
import SideBar from '/src/layouts/sidebar/index';
import Genesys from '/src/Genesys';

function SidebarLayout ({ routes }) {
    const location = useLocation();
    const match = routes.filter(route => matchPath({ path: route.path, exact: true,  strict: false }, location.pathname) && route.path != '*');
    const route = match.pop();
    return route && route.isSidebar && localStorage.getItem('token') ? <SideBar/> : null
}

function Router({ routes }) {

    return (
        <BrowserRouter>
            <SidebarLayout routes={routes}/>
            <Routes>
            {
                routes.map((route, index) => BuilderRoute(route, index))
            }
            </Routes>
            <Genesys/>
        </BrowserRouter>
    )
}

export default Router;